<template>
  <v-dialog v-model="show" :max-width="dialogMaxWidth" :fullscreen="isMobile">
    <product-dialog-content
      :product="product"
      :sales-history="salesHistory"
      :editing-records="editingRecords"
      :cart-charges="cartCharges"
      :is-loading-cart-charges="isLoadingCartCharges"
      :is-loading="isLoading"
      :is-mobile="isMobile"
      :show="show"
      @close="show = false"
    ></product-dialog-content>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import ProductDialogContent from './DialogContent.vue'

export default {
  name: 'ProductDialog',
  components: {
    ProductDialogContent
  },
  computed: {
    ...mapState(
      {
        product: state => state.product.dialog.product,
        salesHistory: state => state.product.dialog.salesHistory,
        editingRecords: state => state.product.dialog.editingRecords,
        cartCharges: state => state.product.dialog.cartCharges,
        isLoadingCartCharges: state => state.product.dialog.isLoadingCartCharges,
        isLoading: state => state.product.dialog.isLoading,
        showDialog: state => state.product.dialog.show,
        isSmaller: state => state.product.dialog.isSmaller
      }
    ),
    show: {
      get () {
        return this.showDialog
      },
      set (value) {
        this.$store.commit('product/SET_SHOW_DIALOG', value)
      }
    },
    dialogMaxWidth: function () {
      return this.isSmaller ? '800px' : '900px'
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>
